<div class="page_wrapper">
  <app-header-new></app-header-new>
  <div class="container wrapper-page header-fix position-relative display-contents">
    <div align="center">
      <div class="row">
        <div class="col-lg-12 text-justify">
          <div class="card m-b-30">
            <div class="card-body">
              <p class="font-size-18 font-weight-500 text-center text-color mb-4  mr-5 pr-0 pr-md-5">Add Member</p>
              <div class="row pl-md-5 pl-0">
                <div class="col-md-3"></div>
                <div class="col-md-6 mt-3 detail-tbl ">
                  <form [formGroup]="patientForm">

                    <div class="row ">
                      <div class="form-group col-md-12 d-flex pl-0 pr-0">
                        <div class="col-md-5 mt-2">
                          <label for="name" class="font-size-17 ">First Name :</label>
                        </div>
                        <div class="col-md-7">
                          <input class="form-control" type="text" placeholder="Enter First Name"
                            formControlName="first_name" id="first_name" maxLength="30"
                            [ngClass]="{ 'is-invalid': patientForm.controls.first_name.errors }" required>
                          <div
                            *ngIf="patientForm.get('first_name').touched && patientForm.get('first_name').hasError('required')"
                            class="invalid-feedback">
                            First Name is required.
                          </div>
                          <div
                            *ngIf="patientForm.get('first_name').touched && patientForm.get('first_name').hasError('pattern')"
                            class="invalid-feedback">
                            First Name is invalid.
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row ">
                      <div class="form-group col-md-12 d-flex pl-0 pr-0">
                        <div class="col-md-5 mt-2">
                          <label for="name" class="font-size-17 ">Last Name :</label>
                        </div>
                        <div class="col-md-7">
                          <input class="form-control" type="text" placeholder="Enter Last Name"
                            formControlName="last_name" id="last_name" maxLength="30"
                            [ngClass]="{ 'is-invalid': patientForm.controls.last_name.errors }" required>
                          <div
                            *ngIf="patientForm.get('last_name').touched && patientForm.get('last_name').hasError('required')"
                            class="invalid-feedback">
                            Last Name is required.
                          </div>
                          <div
                            *ngIf="patientForm.get('last_name').touched && patientForm.get('last_name').hasError('pattern')"
                            class="invalid-feedback">
                            Last Name is invalid.
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row ">
                      <div class="form-group col-md-12 d-flex pl-0 pr-0">
                        <div class="col-md-5 mt-2">
                          <label for="name" class="font-size-17 ">Date of Birth :</label>
                        </div>
                        <div class="col-md-7 m-t-10">
                          <div class="d-flex">
                            <input maxlength="10" class="form-control" placeholder="Date of Birth (DD/MM/YYYY)"
                              name="dob" formControlName="dob" ngbDatepicker #sd="ngbDatepicker"
                              data-date-inline-picker="false" id="dob" [minDate]="miniDate" [maxDate]="currentDate"
                              [ngClass]="{ 'is-invalid': patientForm.controls.dob.errors }" />
                            <div>
                              <button class="btn btn-outline-secondary calendar rounded-0" (click)="sd.toggle()"
                                type="button" style="line-height: 2.5;" id="startDateButton">
                                <span class="fa fa-calendar"></span>
                              </button>
                            </div>
                          </div>
                          <div *ngIf="patientForm.get('dob').hasError('required')" class="invalid-feedback"> Start Date
                            is
                            required
                          </div>
                          <!-- <mat-form-field>
                            <input matInput [matDatepicker]="picker" [min]="minDate" [max]="maxDate"
                              placeholder="Choose a date" formControlName="dob" readonly required>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                            <mat-error *ngIf="patientForm.get('dob').errors">
                              <div
                                *ngIf="patientForm.get('dob').hasError('required') && !(patientForm.get('dob').hasError('matDatepickerMax') || patientForm.get('dob').hasError('matDatepickerMin') || patientForm.get('dob').hasError('matDatepickerParse'))">
                                DOB is required</div>
                              <div
                                *ngIf="patientForm.get('dob').hasError('matDatepickerMax') || patientForm.get('dob').hasError('matDatepickerMin')">
                                DOB is invalid</div>
                            </mat-error>
                          </mat-form-field> -->
                        </div>
                      </div>
                    </div>
                    <div class="row ">
                      <div class="col-md-12 d-flex pl-0 pr-0">
                        <div class="col-md-5 mt-2">
                          <label for="name" class="font-size-17 ">Gender :</label>
                        </div>
                        <div class="col-md-7">
                          <select class="form-control" formControlName="gender"
                            [ngClass]="{ 'is-invalid': patientForm.controls.gender.errors }">
                            <option *ngFor="let g of gender" [value]="g.value"> {{g.key}} </option>
                          </select>
                          <div
                            *ngIf="patientForm.get('gender').touched && patientForm.get('gender').hasError('required')"
                            class="invalid-feedback">
                            Gender is required.
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mt-3">
                      <div class="col-md-12 d-flex pl-0 pr-0">
                        <div class="col-md-5 mt-2">
                          <label for="name" class="font-size-17 ">Email :</label>
                        </div>
                        <div class="col-md-7">
                          {{email_id}}
                          <!-- <input class="form-control" type="text" [value]="email_id" [value]="email_id"
                            formControlName="email_id" id="email_id"> -->
                        </div>
                      </div>
                    </div>


                    <div class="row mt-3">
                      <div class="col-md-12 d-flex pl-0 pr-0">
                        <div class="col-md-5 mt-2">
                          <label for="name" class="font-size-17 ">Relationship :</label>
                        </div>
                        <div class="col-md-7 d-flex">
                          <select class="form-control" formControlName="relation"
                            [ngClass]="{ 'is-invalid': patientForm.controls.relation.errors }">
                            <option *ngFor="let r of relation" [value]="r.value"> {{r.key ? r.key : 'Select Relation'}}
                            </option>
                          </select>
                          <div
                            *ngIf="patientForm.get('relation').touched && patientForm.get('relation').hasError('relation')"
                            class="invalid-feedback">
                            Relationship is required.
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="row mt-3">
                      <div class="col-md-12 d-flex pl-0 pr-0">
                        <div class="col-md-5">
                          <label class="font-size-17 ">contact :</label>
                        </div>
                        <div class="col-md-7 d-md-flex d-block">
                          <div class="col-md-12 pr-0 pl-0">
                            <input type="text" class="form-control" formControlName="contact_no" maxLength="10"
                              minLength="10" required on-focusout="requestOTP()"
                              [ngClass]="{ 'is-invalid': patientForm.controls.contact_no.errors }">
                          </div>


                        </div>
                      </div>
                      <div
                        *ngIf="patientForm.get('contact_no').touched && patientForm.get('contact_no').hasError('required')"
                        class="invalid-feedback text-md-center text-right ml-md-3 ml-0 mr-md-0 mr-5 pr-md-0 pr-4">
                        Phone is required
                      </div>
                      <div
                        *ngIf="patientForm.get('contact_no').hasError('pattern') || patientForm.get('contact_no').hasError('minlength')"
                        class="invalid-feedback text-md-center text-right ml-md-3 ml-0 mr-md-0 mr-5 pr-md-0 pr-4">
                        Phone is invalid
                      </div>
                    </div>

                    <div class="row mt-3">
                      <div class="col-md-12 d-flex pl-0 pr-0">
                        <div class="col-md-5">
                          <label for="name" class="font-size-17 ">OTP :</label>
                        </div>
                        <div class="col-md-7 d-md-flex d-block">
                          <div class="col-md-12 pr-0 pl-0">
                            <input type="password" class="form-control" id="otp" formControlName="otp" maxLength="6"
                              required on-focusout="validateOTP()" autocomplete="new-password"
                              [ngClass]="{ 'is-invalid': patientForm.controls.otp.errors }">
                          </div>
                        </div>
                      </div>
                      <div *ngIf="patientForm.get('otp').touched && wrongOTP"
                        class="invalid-feedback text-md-center text-right ml-md-3 ml-0 mr-md-0 mr-5 pr-md-0 pr-4">
                        OTP is invalid
                      </div>
                      <div *ngIf="patientForm.get('otp').touched && patientForm.get('otp').hasError('required')"
                        class="invalid-feedback text-md-center text-right ml-md-3 ml-0 mr-md-0 mr-5 pr-md-0 pr-4">
                        OTP is required
                      </div>
                    </div>


                  </form>
                  <div class="row justify-content-center pt-5 mr-md-5 mr-0">
                    <button type="button" class="btn btn-primary  btn-sm pl-3 pr-3 pl-md-4 pr-md-4 rounded-0 w-113px"
                      (click)="cancel()">Cancel</button>
                    <button type="button"
                      class="btn btn-primary  btn-sm pl-3 pr-3 pl-md-4 pr-md-4 rounded-0 w-113px ml-5"
                      [disabled]="!patientForm.valid || !validOTP" (click)="addMember()">Save</button>
                  </div>
                  <div class="col-md-3"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer-new></app-footer-new>
</div>